// extracted by mini-css-extract-plugin
export default {"inactive":"InvalidKeys_inactive__svFQ5"};